import { Component, OnInit, Output, EventEmitter } from '@angular/core';
declare var jQuery: any;
import '../../../assets/semantic/semantic.min.js';

@Component({
  selector: 'app-company-modal',
  templateUrl: './company-modal.component.html',
  styleUrls: ['./company-modal.component.css']
})
export class CompanyModalComponent implements OnInit {

  private company: object = {
    email: "",
    name: "",
    phone: ""
  };


  constructor() { }

  ngOnInit() {
  }

  openModal(company) {
    this.company = company;
    jQuery('#company-modal').modal({ inverted: true, closable: false }).modal('show');
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/company-modal/company-modal.component.ts